import React from "react";
import "../css/AcademicExcellence.css";

const AcademicExcellence = () => {
  const academicData = [
    {
      id: 1,
      classTitle: "SEE 10",
      year: "2023",
      metrics: [
        {
          label: "Students scoring 90% and above",
          value: "31.97%",
          color: "#a3d133",
          width: "31.97%",
        },
        {
          label: "Pass percentage",
          value: "100%",
          color: "#a3d133",
          width: "100%",
        },
        {
          label: "School highest score",
          value: "97.6%",
          color: "#00a3e0",
          width: "97.6%",
        },
        {
          label: "School Average",
          value: "81.14%",
          color: "#f2a900",
          width: "81.14%",
        },
      ],
    },
    {
      id: 2,
      classTitle: "SEE 12",
      year: "2023",
      metrics: [
        {
          label: "Students scoring 90% and above",
          value: "22%",
          color: "#e4002b",
          width: "22%",
        },
        {
          label: "Pass percentage",
          value: "100%",
          color: "#e4002b",
          width: "100%",
        },
        {
          label: "School highest score",
          value: "96.2%",
          color: "#002f6c",
          width: "96.2%",
        },
        {
          label: "School Average",
          value: "82.7%",
          color: "#00a3e0",
          width: "82.7%",
        },
      ],
    },
    {
      id: 3,
      classTitle: "SEE 10",
      year: "2024",
      metrics: [
        {
          label: "School Highest Score",
          value: "98.6%",
          color: "#e4002b",
          width: "98.6%",
        },
        {
          label: "Pass Result",
          value: "100%",
          color: "#0d2137",
          width: "100%",
        },
      ],
    },
    {
      id: 4,
      classTitle: "SEE 12",
      year: "2024",
      metrics: [
        {
          label: "School Highest Score",
          value: "96.2%",
          color: "#a3d133",
          width: "96.2%",
        },
        {
          label: "Pass Result",
          value: "100%",
          color: "#00a3e0",
          width: "100%",
        },
      ],
    },
    {
      id: 5,
      classTitle: "SEE 10 Morning Shift:",
      year: "2025",
      metrics: [
        {
          label: "School Highest Score",
          value: "98%",
          color: "#f2a900",
          width: "98%",
        },
        {
          label: "Pass Result",
          value: "100%",
          color: "#0d2137",
          width: "100%",
        },
      ],
    },
    {
      id: 6,
      classTitle: "SEE 10 Afternoon Shift:",
      year: "2025",
      metrics: [
        {
          label: "School Highest Score",
          value: "95.6%",
          color: "#a3d133",
          width: "95.6%",
        },
        {
          label: "Pass Result",
          value: "100%",
          color: "#00a3e0",
          width: "100%",
        },
      ],
    },
    {
      id: 7,
      classTitle: "SEE 12",
      year: "2025",
      metrics: [
        {
          label: "School Highest Score",
          value: "97.4%",
          color: "#e4002b",
          width: "97.4%",
        },
        {
          label: "Pass Result",
          value: "100%",
          color: "#0d2137",
          width: "100%",
        },
      ],
    },
  ];

  return (
    <section className="academic-excellence-section">
      <div className="academic-container">
        {}
        <div className="academic-intro-header">
          <h2 className="academic-main-title">
            Consistent Academic Excellence Year After Year
          </h2>
          <div className="academic-paragraphs">
            <p className="academic-sub-text font-bold-prefix">
              <strong>Recommendation:</strong> Sahara Public Secondary School
              consistently delivers strong board outcomes in a positive learning
              environment that supports achievement, confidence, and long-term
              success.
            </p>
            <p className="academic-sub-text">
              As one of the premium secondary schools, Sahara continues to set
              benchmarks in academic excellence and holistic student
              development, shaping future-ready global citizens.
            </p>
            <p className="academic-sub-text">
              Our board results highlight strong pass rates, high scorers, and a
              culture of academic discipline supported by individual attention.
            </p>
            <p className="academic-sub-text">
              Consistent board results reflect the strength of our teaching,
              personalised support, and student commitment.
            </p>
          </div>
        </div>

        {}
        <div className="academic-results-grid">
          {academicData.map((data) => (
            <div key={data.id} className="result-data-card">
              {}
              <div className="result-card-header">
                <h3 className="class-title-text">{data.classTitle}</h3>
                <span className="result-year-badge">{data.year}</span>
              </div>
              <hr className="card-divider-line" />

              {}
              <div className="card-metrics-body">
                {data.metrics.map((metric, index) => (
                  <div key={index} className="metric-row-item">
                    <div className="metric-text-label-row">
                      <span className="metric-percentage-val">
                        {metric.value}
                      </span>
                      <span className="metric-label-desc">{metric.label}</span>
                    </div>
                    {}
                    <div className="progress-track-bar">
                      <div
                        className="progress-filled-fill"
                        style={{
                          backgroundColor: metric.color,
                          width: metric.width,
                        }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AcademicExcellence;
